import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-freezing-preservation',
  standalone: true,
  imports: [],
  templateUrl: './freezing-preservation.component.html',
  styleUrl: './freezing-preservation.component.scss'
})
export class FreezingPreservationComponent implements OnInit {

  constructor(private route: Router,
    private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/fertility-preservation",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);



    this.titleService.setTitle('Fertility Preservation in Kannur | Egg, Sperm & Embryo Freezing');
    this.metaService.updateTag({
      name: 'description',
      content: 'Secure your reproductive future with expert Fertility Preservation at Ncare IVF Centre in Kannur. We offer advanced egg, sperm, and embryo freezing for individuals and couples.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'Fertility Freezing, Fertility Preservation, Fertility Preservation Service, Fertility Preservation in Kannur, Fertility Preservation in Kerala, Fertility Freezing Service'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Fertility Preservation in Kannur | Egg, Sperm & Embryo Freezing'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Secure your reproductive future with expert Fertility Preservation at Ncare IVF Centre in Kannur. We offer advanced egg, sperm, and embryo freezing for individuals and couples.'
    });
  }
  contactus() {
    this.route.navigate(['/contact-us']);
  }
}
